import * as React from "react";

import themeDark from "./themeDark";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { MuiThemeProvider } from "@material-ui/core/styles";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import DoneIcon from "@material-ui/icons/Done";
import { Button } from "@material-ui/core";
import moment from "moment";

const useStyles = (step: number) => {
  return makeStyles((theme) => ({
    nameGrid: {
      backgroundColor: "#02489D",
      height: 82,
      display: "flex",
      alignItems: "center",
    },
    arrowContainer: {
      width: 82,
      height: 82,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    arrowBox: {
      width: 51,
      height: 51,
      backgroundColor: step <= -1 ? "#225594" : "#00152E",
      borderRadius: 26,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2,
    },
    arrow: {
      color: "#FFF",
    },
    bottomGrid: {
      backgroundColor: "#002047",
      height: 82,
      display: "flex",
      alignItems: "center",
    },
    boldText: {
      fontSize: 21,
      fontWeight: 900,
      color: "#FFF",
      marginLeft: 4,
      lineHeight: 1.2,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    lightText: {
      fontSize: 21,
      fontWeight: 400,
      color: "#FFF",
      marginLeft: 4,
      lineHeight: 1.2,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    waitingButton: {
      fontSize: 14,
      color: "#03090E",
      fontWeight: 700,
      backgroundColor: "#F4B827",
      height: "39px",
      width: "143px",
      minWidth: "unset",
    },
  }))();
};

const BorderedText = ({ text }: any) => {
  return (
    <Typography
      variant="body1"
      component="div"
      style={{ fontSize: 16, fontWeight: 900, color: "#FFF", border: "1px solid white", padding: "0px 4px" }}
    >
      {text}
    </Typography>
  );
};

const mlsToDuration = (ms: number) => {
  return moment.utc(ms).format("HH:mm:ss");
};

const getTime = (date: string) => {
  return new Date(date).toString().substr(16, 5);
};

function TransferWidget({ tripStatus, moreInfoClick, step = -1, updateStep, data, setShowWaitingTimeModal,setWaitTimeTransferStatus,setWaitTimeClick }: any) {
  const classes = useStyles(step);

  const updateStepInner = (currentPos: number) => {
    if (currentPos == step) {
      updateStep(-1);
    } else if (currentPos == step + 1) {
      updateStep(1);
    }
  };

  return (
    <MuiThemeProvider theme={themeDark}>
      <div style={{ display: "flex", justifyContent: "center", margin: 10 }}>
        <Grid container>
          <Grid item xs={12} sm={6} className={classes.nameGrid} style={{ paddingLeft: 34 }}>
            <Typography
              variant="body1"
              component="div"
              style={{ fontSize: 30, fontWeight: 400, color: "#FFF", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
            >
              {`${data.firstName} ${data.lastName}`}
            </Typography>
            <Typography
              onClick={moreInfoClick}
              variant="body1"
              component="div"
              style={{
                fontSize: 21,
                fontWeight: 400,
                color: "#F4B827",
                marginLeft: 23,
                cursor: "pointer",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              More Info
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.nameGrid} style={{ position: "relative" }}>
            <Grid style={{ display: "flex", flex: 1, flexDirection: "column" }}>
              <Typography
                variant="body1"
                component="div"
                style={{ fontSize: 21, fontWeight: 400, color: "#FFF", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
              >
                Scheduled Pickup
                <Typography variant="body1" component="span" style={{ fontSize: 21, fontWeight: 900, color: "#FFF", marginLeft: 4 }}>
                  {getTime(data.scheduledDate)}
                </Typography>
              </Typography>
              <Typography variant="body1" component="div" style={{ fontSize: 21, fontWeight: 400, color: "#FFF" }}>
                Priority
                <Typography variant="body1" component="span" style={{ fontSize: 21, fontWeight: 900, color: "#FFF", marginLeft: 4 }}>
                  {data.priority || 3}
                </Typography>
              </Typography>
            </Grid>
            <span
              style={{
                width: "min(38%, 210px)",
                height: 5,
                backgroundColor: step <= -1 || tripStatus == 1 ? "#225594" : "#00152E",
                borderRadius: 2,
                position: "absolute",
                right: 55,
                top: 40,
                zIndex: 1,
              }}
            ></span>
            <div
              className={classes.arrowContainer}
              style={{
                backgroundColor: step <= -1 || tripStatus == 1 ? "#FFFFFF40" : step >= 1 ? "#F4B827" : "#02489D",
                cursor: step == 0 || step == 1 ? "pointer" : "auto",
              }}
              onClick={() => updateStepInner(1)}
            >
              <span className={classes.arrowBox}>
                <ArrowUpwardIcon className={classes.arrow} />
              </span>
            </div>
            <div
              className={classes.arrowContainer}
              style={{
                backgroundColor: step <= -1 || tripStatus == 1 ? "#FFFFFF40" : step >= 2 ? "#F4B827" : "#02489D",
                cursor: step == 1 || step == 2 ? "pointer" : "auto",
              }}
              onClick={() => updateStepInner(2)}
            >
              <span className={classes.arrowBox}>
                <ArrowForwardIcon className={classes.arrow} />
              </span>
            </div>
            <div
              className={classes.arrowContainer}
              style={{
                backgroundColor: step <= -1 || tripStatus == 1 ? "#FFFFFF40" : step >= 3 ? "#F4B827" : "#02489D",
                cursor: step == 2 || step == 3 ? "pointer" : "auto",
              }}
              onClick={() => updateStepInner(3)}
            >
              <span className={classes.arrowBox}>
                <ArrowDownwardIcon className={classes.arrow} />
              </span>
            </div>
            <div
              className={classes.arrowContainer}
              style={{
                backgroundColor: step <= -1 || tripStatus == 1 ? "#FFFFFF40" : step >= 4 ? "#F4B827" : "#02489D",
                cursor: step == 3 || step == 4 ? "pointer" : "auto",
              }}
              onClick={() => updateStepInner(4)}
            >
              <span className={classes.arrowBox}>
                <DoneIcon className={classes.arrow} />
              </span>
            </div>
          </Grid>
          {step == 1 && (
            <Grid item xs={12} sm={12} className={classes.bottomGrid} style={{ paddingLeft: 34 }}>
              <p style={{ fontSize: 21, marginRight: 25 }}>
                Wait time:{" "}
                {data?.pickUpTransferWaitTimes && data.pickUpTransferWaitTimes.length > 0
                  ? mlsToDuration(data.pickUpTransferWaitTimes.reduce((sum: any, curr: any) => curr.waitDuration.totalMilliseconds + sum, 0))
                  : "00:00:00"}
              </p>

              <Button
                onClick={() => {
                    setShowWaitingTimeModal(true);
                    setWaitTimeClick(true);
                    localStorage.setItem("ShowWaitModel","true");
                    setWaitTimeTransferStatus(7);
                  }}
                variant="contained"
                className={classes.waitingButton}
              >
                I'm Kept Waiting
              </Button>
            </Grid>
          )}
          {step == 3 && (
            <Grid item xs={12} sm={12} className={classes.bottomGrid} style={{ paddingLeft: 34 }}>
              <p style={{ fontSize: 21, marginRight: 25 }}>
                Wait time:{" "}
                {data?.dropOffTransferWaitTimes && data.dropOffTransferWaitTimes.length > 0
                  ? mlsToDuration(data.dropOffTransferWaitTimes.reduce((sum: any, curr: any) => curr.waitDuration.totalMilliseconds + sum, 0))
                  : "00:00:00"}
              </p>

              <Button
                onClick={() => {
                  setShowWaitingTimeModal(true);
                  setWaitTimeClick(true)
                  localStorage.setItem("ShowWaitModel","true");
                  setWaitTimeTransferStatus(9);
                }}
                variant="contained"
                className={classes.waitingButton}
              >
                I'm Kept Waiting
              </Button>
            </Grid>
          )}
          {step != 1 && step != 3 && (
            <>
              <Grid item xs={12} sm={6} className={classes.bottomGrid} style={{ paddingLeft: 34 }}>
                <BorderedText text="FROM" />
                <div style={{ display: "flex", flexDirection: "column", marginLeft: 19, width: "calc(100% - 115px)" }}>
                  <Typography variant="body1" component="span" className={classes.boldText}>
                    {(data.originCustomerLocationId ? data.originLocationName : data.originStreetAddress || "").toUpperCase()}
                  </Typography>
                  <Typography variant="body1" component="span" className={classes.lightText}>
                    {(data.originCustomerLocationId
                      ? `${data.originWardName ? ` ${data.originWardName}` : ""}${data.originBed ? `, ${data.originBed || ""}` : ""}`
                      : `${data.originSuburb || ""} ${data.originState}`
                    ).toUpperCase()}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} className={classes.bottomGrid}>
                <BorderedText text="TO" />
                <div style={{ display: "flex", flexDirection: "column", marginLeft: 19 }}>
                  <Typography variant="body1" component="span" className={classes.boldText}>
                    {(data.destinationCustomerLocationId ? data.destinationLocationName : data.destinationStreetAddress || "").toUpperCase()}
                  </Typography>
                  <Typography variant="body1" component="span" className={classes.lightText}>
                    {(data.destinationCustomerLocationId
                      ? `${data.destinationWardName ? ` ${data.destinationWardName}` : ""}${
                          data.destinationBed ? `, ${data.destinationBed || ""}` : ""
                        }`
                      : `${data.destinationSuburb || ""} ${data.destinationState}`
                    ).toUpperCase()}
                  </Typography>
                </div>
              </Grid>
            </>
          )}
        </Grid>
      </div>
    </MuiThemeProvider>
  );
}

export default React.memo(TransferWidget);
